import { asyncThunkMutationWithErrors } from 'Admin/Store/asyncThunkHandler'
import installmentNoteSaveMutation from 'AdminInvoices/Mutations/installmentNoteSaveMutation'
import installmentNoteDeleteMutation from 'AdminInvoices/Mutations/installmentNoteDeleteMutation'

export const mutationInstallmentNoteSave = asyncThunkMutationWithErrors(
  'installmentNotes/mutationInstallmentNoteSave',
  installmentNoteSaveMutation,
  ({ data }) => data.installmentNoteSave.note
)

export const mutationInstallmentNoteDelete = asyncThunkMutationWithErrors(
  'installmentNotes/mutationInstallmentNoteDelete',
  installmentNoteDeleteMutation,
  ({ data }) => data.installmentNoteDelete.success
)
